import script from "./TraitShopBalance.vue?vue&type=script&setup=true&lang=js"
export * from "./TraitShopBalance.vue?vue&type=script&setup=true&lang=js"

import "./TraitShopBalance.vue?vue&type=style&index=0&id=64793170&lang=scss"

const __exports__ = script;

export default __exports__